import { useState, useEffect } from 'react';
import './PageLoader.css';
import logoImg from '../assets/logo.png';

export default function PageLoader() {
  const [hiding, setHiding] = useState(false);
  const [gone, setGone]     = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setHiding(true), 1900);
    const t2 = setTimeout(() => setGone(true),   2450);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  if (gone) return null;

  return (
    <div className={`page-loader${hiding ? ' page-loader--out' : ''}`}>
      <div className="pl-logo-wrap">
        <div className="pl-ring-outer" />
        <div className="pl-ring-inner" />
        <img src={logoImg} alt="Mad Marketing Club" className="pl-logo" />
      </div>
      <div className="pl-bar-track">
        <div className="pl-bar-fill" />
      </div>
    </div>
  );
}
